<template>
    <span class="text-left">New Environment: {{ datetime }} at {{ ip }}</span>
    <br>
    <span class="text-left">This is a terminal representation of "cklaassen.github.io"</span>
    <span class="text-left">All content accessible on the GUI is accessible through custom terminal commands</span>
    <!-- <span class="text-left">Type <span class="italic">help</span> for a list of possible commands</span> -->
</template>

<script>
import { ref } from 'vue'
import $ from 'jquery'

export default {
  name: 'TerminalLine',
  setup: function () {
    const datetime = ref('')
    const today = new Date()
    const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
    const time = today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds()
    datetime.value = date + ' ' + time

    const ip = ref('')

    const modifyIp = (newIp) => {
      ip.value = newIp
    }

    return {
      datetime,
      ip,
      modifyIp
    }
  },
  created: function () {
    $.getJSON('https://api.ipify.org?format=json', function (data) {
      console.log(data.ip)
      this.modifyIp(data.ip)
    }.bind(this))
  }
}
</script>
